<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="handleSubmit">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" :disabled="status.loggingIn" v-model="username" name="username" class="form-control" placeholder="Username" autocomplete="username email" :class="{ 'is-invalid': submitted && !username }"/>
                   <div v-show="submitted && !username" class="invalid-feedback">Username is required</div>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" :disabled="status.loggingIn" v-model="password" name="password" class="form-control" placeholder="Password" autocomplete="current-password"  :class="{ 'is-invalid': submitted && !password }"/>
                  <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>
                  </b-input-group>
                  <b-row>
                    <b-col>
                    <div class="form-group">
                      <b-button block type="submit" variant="primary" class="px-4 btn btn-primary" :disabled="status.loggingIn">Login</b-button>
                      <img v-show="status.loggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    </div>
                    </b-col>
                    <b-col cols="6" class="text-right" style="display:none;">
                        <div>
                            
                        <b-dropdown id="dropdown-1" text="languages" class="m-md">
                          <b-dropdown-item v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)"> 
                            <!-- <flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}} -->
                          </b-dropdown-item>
                        </b-dropdown>

                        </div>
                        <!-- {{ $t('welcomeMsg') }} -->
                      <b-button variant="link" class="px-0">
                        <!-- {{ $t('contactUs') }} -->
                        </b-button>
                    </b-col>
                  </b-row>
                </b-form>

              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <img src="/img/brand/reverse-logo.png" width="240" height="90" alt="YPB Logo">
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style>
</style>
<script>
import { mapState, mapActions } from 'vuex'
import { i18n } from '@/plugins/i18n';

export default {
  data () { 
    this.$i18n.locale = 'en';
    return {
      languages: [            
        { flag: 'us', language: 'en', title: 'English' },            
        { flag: 'cn', language: 'cn', title: 'Chinese' }        
        ],    
      username: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    ...mapState('account', ['status'])
  },
  created () {
    this.logout();
  },
  methods: {
    changeLocale(locale) {      
      i18n.locale = locale;   
    },
    ...mapActions('account', ['login', 'logout']),
    handleSubmit (e) {
      this.submitted = true;
      const { username, password } = this;
      if (username && password) {
        this.login({ username, password });
      }
    }
  }
};
</script>
